// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "serviceCard-2ygWI";
var _3 = "header-1Ecbw";
var _4 = "headerText-8_XMs";
var _5 = "headerPrice-1PmKO";
var _6 = "description-3gpCO";
var _7 = "buttons-1CRN2";
var _8 = "active-15VF2";
export { _1 as "__esModule", _2 as "serviceCard", _3 as "header", _4 as "headerText", _5 as "headerPrice", _6 as "description", _7 as "buttons", _8 as "active" }
export default { "__esModule": _1, "serviceCard": _2, "header": _3, "headerText": _4, "headerPrice": _5, "description": _6, "buttons": _7, "active": _8 }
